export default "__VITE_ASSET__DSbfa9DZ__"